<template>
  <section class="cat" :class="{ collapsed: collapsed }">
    <div class="cat-head" @click="collapsed = !collapsed">
      <h2 class="cat-title">{{ category }}</h2>
      <span class="cat-count">{{ prompts.length }}</span>
      <span class="cat-chev">▾</span>
    </div>

    <div v-show="!collapsed" class="cat-body">
      <PromptCard
        v-for="(p, i) in prompts"
        :key="p.id"
        :prompt="p"
        :open="openFirst && i === 0"
        :saving="savingId === p.id"
        :saved="savedId === p.id"
        :previewing="previewingId === p.id"
        @save="$emit('save', $event)"
        @toggle="$emit('toggle', $event)"
        @preview="$emit('preview', $event)"
      />
    </div>
  </section>
</template>

<script>
import PromptCard from './PromptCard.vue'

export default {
  name: 'PromptCategory',
  components: { PromptCard },
  props: {
    category: { type: String, required: true },
    prompts: { type: Array, default: () => [] },
    openFirst: { type: Boolean, default: false },
    savingId: { type: Number, default: null },
    savedId: { type: Number, default: null },
    previewingId: { type: Number, default: null },
  },
  data() {
    return {
      collapsed: false,
    }
  },
}
</script>

<style scoped>
.cat { margin-bottom: 26px; }
.cat-head { display: flex; align-items: center; gap: 14px; cursor: pointer; user-select: none; padding: 4px 0; }
.cat-title { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 22px; text-transform: uppercase; letter-spacing: .6px; margin: 0; }
.cat-count { font-size: 11px; font-weight: 600; color: #3A33C7; background: #EEEDFB; padding: 3px 9px; border-radius: 999px; }
.cat-chev { margin-left: auto; color: #56565E; transition: transform .2s ease; }
.cat.collapsed .cat-chev { transform: rotate(-90deg); }
.cat-body { margin-top: 14px; display: flex; flex-direction: column; gap: 12px; }
</style>
